/** Spec 05 card 4: the inline note composer under a transcript segment. "Only you" by default. */
import { useEffect, useRef, useState } from "react";
import { ChevronDown, Lock } from "lucide-react";
import { Dropdown } from "../shared/Dropdown";
import { notesStore } from "../../stores/notesStore";
import { meetingStore } from "../../stores/meetingStore";
import { clock } from "../../lib/format";
import type { Note } from "../../types";

export function NoteComposer({ t, initial, canShare }: { t: number; initial: Note | null; canShare: boolean }) {
  const [text, setText] = useState(initial?.text ?? "");
  const [visibility, setVisibility] = useState<Note["visibility"]>(initial?.visibility ?? "private");
  const ref = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    ref.current?.focus();
    meetingStore.getState().setFollowMode("annotating"); // writing pauses auto-scroll
  }, []);
  return (
    <div className="note-composer" onKeyDown={(e) => {
      if (e.key === "Escape") notesStore.getState().closeComposer();
      if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) void notesStore.getState().save(text.trim(), visibility);
    }}>
      <div className="note-head">
        <span>Note · {clock(t)}</span>
        <Dropdown className="note-visibility" label="Who can see this note" size="sm" align="end" value={visibility} onChange={setVisibility}
          icon={<Lock size={11} aria-hidden />} chevron={<ChevronDown size={11} aria-hidden />}
          options={[{ value: "private" as Note["visibility"], label: "Only you" }, ...(canShare ? [{ value: "team" as Note["visibility"], label: "Your team" }] : [])]} />
      </div>
      <textarea ref={ref} rows={3} aria-label="Note" value={text} onChange={(e) => setText(e.target.value)} />
      <div className="note-actions">
        <button className="note-cancel" onClick={() => notesStore.getState().closeComposer()}>Cancel</button>
        <button className="btn btn--primary btn--small" onClick={() => void notesStore.getState().save(text.trim(), visibility)}>Save note</button>
      </div>
    </div>
  );
}
